module.exports = __webpack_public_path__ + "static/about-static-b7e5fc5a8a0e77883851498016c186b7.jpg";